/**
 * Página de éxito del checkout AR (/ar/invitacion).
 * Mercado Pago redirige aquí (back_url) tras el pago; mostramos gracias y botón para ingresar al grupo.
 * successPath enviado en create-subscription: "/ar/invitacion/success"
 */

import GraciasAr from "@/components/GraciasAr";

export default function InvitacionArSuccess() {
  return <GraciasAr />;
}
